"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onClickStopPropagation = void 0;
/**
 * A higher-order function that takes an event handler and returns an event
 * handler that stops the propagation of the event.
 */
const onClickStopPropagation = f => e => {
    e.stopPropagation();
    f(e);
};
exports.onClickStopPropagation = onClickStopPropagation;
//# sourceMappingURL=onClickStopPropagation.js.map